export const headerHeight = 61;
export const bottomNavbarHeight = 71;
